export default __webpack_public_path__ + "static/media/i129hp.63992e5d.webp";